import React from 'react';
import type TrashedDirectLinkType from '@atlassian/jira-plan-trashed-direct-link/src/ui/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyTrashedPlanDirectLink = lazyForPaint<typeof TrashedDirectLinkType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-plan-trashed-direct-link", jiraSpaEntry: "async-plan-trashed-direct-link" */ '@atlassian/jira-plan-trashed-direct-link'
		),
	),
);

export const TrashedPlanDirectLink = (): React.JSX.Element => (
	<LazyPage
		Page={LazyTrashedPlanDirectLink}
		pageId="trashed-plan-direct-link"
		shouldShowSpinner={false}
	/>
);
